/** A labelled field of the analyst-fact dialogs, with what is wrong with it. */
import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'
import type { FieldProblem } from './fact-forms'

export function FactField({
  id,
  label,
  problem,
  children,
}: {
  id: string
  label: string
  problem?: FieldProblem
  children: React.ReactNode
}) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      {children}
      {problem && (
        <p role="alert" className="text-2xs text-destructive">
          {t(`analystFacts.problems.${problem}`)}
        </p>
      )}
    </div>
  )
}
